import { MovementDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedList } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { toFeatured$ } from '../../serializer/featured';
import { MovementFeaturedCard } from '../movement-featured-card';

@Component({
    components: {
        sEntityFeaturedList: EntityFeaturedList,
    },
    props: ['targetRouteName'],
    template: require('./movement-featured-list.html'),
})
export class MovementFeaturedList extends ReactiveVue {
    public $movementDataStore: MovementDataStore;
    public featuredStates = MovementDataStore.featuredStates;
    public sortFields = MovementDataStore.sortFields;
    public serializer = toFeatured$;
    public targetRouteName;
    
    private customCard: Vue.Component = MovementFeaturedCard
    private customCardProps: Object = {
        needsToFetchFeatured: false,
    }
}
